import { ZmMessage } from '@/components/zoom-ui-plus/message/index';
import { translation } from '@/plugins/i18n';
import { getCurrentSoftBundleName, getSoftBundleMessages } from '@/views/config/soft-bundle/helper';

// pop up message with coupon
export const softBundlePopUpMsgWithCoupon = () => {
  const bundleName = getCurrentSoftBundleName();
  const name = getSoftBundleMessages(bundleName)?.name ?? bundleName;
  const message = translation('softBundle.incompatibleForCouponTips', [translation(name)]);

  // Track banner impression
  window.$tracking?.buyInteraction?.(
    'banner - product level',
    `${message} - impression`
  );

  return ZmMessage({
    type: 'warning',
    message, dangerouslyUseHTMLString: true,
    duration: 5000,
    onClose: () => {
      // Track banner close
      window.$tracking?.buyInteraction?.(
        'banner - product level',
        `${message} - close`
      );
    }
  });
}
